// extracted by mini-css-extract-plugin
module.exports = {"root":"SortAdornment_root__3dv9k","icon":"SortAdornment_icon__eNpKb","up":"SortAdornment_up__3cMdK","down":"SortAdornment_down__IJsRl","active":"SortAdornment_active__Ubm0c"};